import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { checkAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          console.error('No session_id found in URL');
          navigate('/admin/login');
          return;
        }

        const sessionId = sessionIdMatch[1];

        // Exchange session_id for session_token
        const response = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        const userData = response.data.user;

        // Check if user is admin
        if (!userData.is_admin) {
          alert('Accès refusé. Seul le propriétaire peut accéder au dashboard.');
          navigate('/');
          return;
        }

        // Update auth context
        await checkAuth();

        // Redirect to admin dashboard with user data
        navigate('/admin/dashboard', { 
          replace: true,
          state: { user: userData }
        });
      } catch (error) {
        console.error('Auth callback error:', error);
        alert('Erreur d\'authentification. Veuillez réessayer.');
        navigate('/admin/login');
      }
    };

    processSession();
  }, [location, navigate, checkAuth]);

  return (
    <div className="min-h-screen bg-[#ECEC75] flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-[#D4AF37] mx-auto mb-4"></div>
        <p className="text-xl font-semibold text-black">Authentification en cours...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
